const appConfig = {
    appId: "underwriterQore-e36161f1-bced-4eae-a8b9-2c901959ce89",
    appName: "Underwriter",
    site: 'underwriter-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/underwriterQoreAppIcon.png"
};

export default appConfig;
